import Chevron from 'components/Chevron';
import Link from 'next/link';
import styles from './Link.module.css';

const BackLink = ({ to }: { to?: 'games' | 'prizes' }) => {
  return (
    <Link href={`/token-town${to ? `?tab=${to}` : ''}`}>
      <div className={`${styles.linkContainer} ${styles.extraPadding}`}>
        <Chevron direction={'left'} />

        <p className={styles.linkLabel} style={{ paddingBottom: 5 }}>
          BACK TO TOKEN TOWN
        </p>
      </div>
    </Link>
  );
};

export default BackLink;
